
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import Detail from './Detail.vue'
import Courses from './Courses.vue'
import BigBgImg from '../BigBgImg/index.vue'
import { Observer } from 'mobx-vue'
import type { CalligraphyLevel2JsonResp } from '@xt/client/utils/activities/types.d.ts'

@Observer
@Component({
  components: {
    BigBgImg,
    Detail,
    Courses
  }
})
export default class Header extends Vue {
  @Prop({ required: true }) readonly dataSource: CalligraphyLevel2JsonResp

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
